<template>
  <base-toggle
    v-bind="{ value, disabled }"
    v-model="modelValue"
    class="flex-col center gap-y-1 i-flex gap-y-2"
    data-test-id="vf-color-filter"
  >
    <span
      class="relative flex center ring ring-inset forced-colors:b peer-focus-visible:outline-auto"
      :class="[
        brandClasses.rounded,
        disabled ? 'bg-cross ring-grey-50' : brandClasses.ring,
        {
          '!ring-grey-10': value && isArray(modelValue) && modelValue.includes(value),
        },
      ]"
    >
      <vf-color-swatch
        :id
        :class="[
          brandClasses.swatch,
          disabled && brandClasses.swatchDisabled,
        ]"
        :class-inner="[
          'rounded-full',
          brandClasses.swatchInner,
          disabled && brandClasses.swatchInnerDisabled,
        ]"
        :color
      />
      <vf-icon
        v-if="hasIcon"
        class="absolute op-0"
        :class="[
          isLowContrast
            ? 'c-black forced-colors:prefer-dark:invert'
            : 'c-white forced-colors:prefer-light:invert',
          {
            'op-100': value && isArray(modelValue) && modelValue.includes(value),
          },
        ]"
        name="check"
        size="md"
      />
    </span>
    <span
      v-if="$slots.default"
      class="w-full truncate text-center"
      :class="[
        brandClasses.label,
        { 'c-grey-30': disabled },
      ]"
    >
      <!-- @slot Slot for label -->
      <slot />
    </span>
  </base-toggle>
</template>

<script lang="ts" setup>
const { color } = defineProps<{
  /**
   * The ID of the color filter to check for custom values
   */
  id?: string
  /**
   * Sets the value of the color filter
   */
  value?: string
  /**
   * Sets the disabled state of the color filter
   */
  disabled?: boolean
  /**
   * Color value as an array of color codes or 'multicolor'
   */
  color?: string[]
}>()

const modelValue = defineModel<boolean | string[]>()

const { brandClasses, hasIcon } = useAppConfig().components.vf.colorFilter

const isLowContrast = hasHighBrightness((color?.length === 1 && color[0] !== 'multicolor') ? color[0] : '')
</script>
